<template>
  <div class="wrapper-box">
    <web-header></web-header>
    <web-slide :data="data"></web-slide>
    <web-products :products="products"></web-products>
    <web-parallax></web-parallax>
    <web-footer></web-footer>
    <web-arrow-up></web-arrow-up>
  </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import products from "@/components/categories/products";
import arrowUp from "@/components/arrowUp.vue";
import bg from "../../assets/images/categories/banners/titulo_completefood.jpg";
import bgMob from "../../assets/images/categories/banners/titulo_completefood_mobile.jpg";

import img1 from "../../assets/images/products/completefood_conejos.jpg";
import img2 from "../../assets/images/products/completefood_chinchillas.jpg";

export default {
  name: "completeFood",
  data() {
    return {
      data: [
        {
          html:
            " <h1>COMPLETE FOOD – ALL IN ONE</h1><p>Se recomienda incorporar en la dieta de Conejos, Chinchillas y Cobayos, verduras frescas, pasturas de Heno, alfalfas en cubo, rama o pellets.<br> Las pasturas son la base nutricional de estos roedores.</p>",
          style:
            "background:url(" +
            this.getBg() +
            ") no-repeat; background-size:cover;    background-position: center; height:300px; "
        }
      ],
      products: [
        {
          image: img1,
          title: "ALIMENTO BALANCEADO PARA CONEJOS",
          description: `El Balanceado para Conejos de Nelsoni Ranch provee una optima nutrición con todas las vitaminas y nutrientes, manteniendo a su roedor vital y feliz.<br>
          Especialmente formulado para diferentes variedades de conejos, balanceado cría profesional. <br>
          Se recomienda incorporar en la dieta de todo conejo verduras frescas, Heno Nelsoni Ranch, alfalfas en cubo, rama o pellets. Las pasturas son la base nutricional de los roedores.<br>
          Ingredientes: alfalfa, cascarilla de soja, expeler de girasol integral, afrecho de arroz, zeolita, núcleo vitamínico AD3E, sal.<br>
          Composición centesimal: proteína bruta 16% min. Grasa bruta 3% min. Fibra bruta 20% min. /25% máx.  Humedad 13% máx. Calcio 0,8% min. /1% máx. Fósforo 0,4% min. /0,5% máx.  <br>
          Aditivos por kg: VIT A 10000 UI / VIT D3 1500UI / VIT E 50UI<br>
          Energía Metabolizante: 1800 Kcal por kg `,
          extraData: "Presentación 750 gr. y bolsas de 10 Kg.",
          component:{
            name:'data-table',
            type:'conejos'
          }
        },
        {
          image: img2,
          title: "MIX CHINCHILLAS",
          description: `La chinchilla tiene requerimientos específicos y no debe ser alimentada con formulas para otros roedores. La composición de este alimento esta adaptado a sus exigencias biológicas.<br> Se le puede brindar tanto a animales de cría como a las mascotas. Ingredientes: pellets compuestos por alfalfa de primera calidad, vitaminas y minerales esenciales para mejorar el pelo, combatir el estrés, previene enfermedades hepáticas y contiene probióticos para facilitar absorción de nutrientes.`,
          extraData: "Presentación 750 gr. y bolsas de 10 Kg.",
           component:{
            name:'data-table',
            type:'chinchillas'
          }
        }
      ]
    };
  },
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webProducts: products,
    webArrowUp: arrowUp
  },
  methods: {
    detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg() {
      if (this.detectmob()) {
        return bgMob;
      }
      return bg;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/categories/completeFood.vue